import {Injectable} from '@angular/core';
import {UserConfirmationInfo} from '../models/user';
import {CommonService} from './common.service';
import {LocalStorageService} from './local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private localStorageService: LocalStorageService,
              private commonService: CommonService) {
  }

  isValid(): boolean {
    return !!this.localStorageService.get('token');
  }


  async getPendingUsers() {
    try {
      const request: any = await this.commonService.getList('people/pending');
      return request.object;
    } catch (e) {
      throw e;
    }
  }

  async updatePendingUser(userModel: UserConfirmationInfo) {
    try {
      const request: any = await this.commonService.updateItem('people/pending', userModel);
      return request.object;
    } catch (e) {
      throw e;
    }
  }
}
